<script setup lang="ts">
import InputError from '@/components/InputError.vue'
import { Label } from '@/components/ui/label'

defineProps<{
  label: string
  required?: boolean
  errors?: string[]
}>()
</script>

<template>
  <div class="app-form-field grid gap-2">
    <Label class="text-xs text-gray-400">
      {{ label }}
      <span v-if="required" class="text-destructive">*</span>
    </Label>
    <slot />
    <InputError v-if="errors" :messages="errors" />
  </div>
</template>
